import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Bell, BellOff } from 'lucide-react';
import { useAuth, API } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

export default function NotificationManager() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [permission, setPermission] = useState('default');
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    // Check if browser supports notifications
    if ('Notification' in window && 'serviceWorker' in navigator) {
      setSupported(true);
      setPermission(Notification.permission);
    }
  }, []);

  const requestPermission = async () => {
    if (!supported) {
      toast.error('Your browser does not support notifications');
      return;
    }

    try {
      const perm = await Notification.requestPermission();
      setPermission(perm);

      if (perm === 'granted') {
        toast.success('🔔 Notifications enabled!');
        
        // Show test notification immediately
        setTimeout(() => {
          new Notification('Chronos Time Bank', {
            body: '✅ You\'ll now receive notifications!',
            icon: '/chronos-logo.png'
          });
        }, 500);
      } else if (perm === 'denied') {
        toast.error('Notifications blocked. Change in browser settings.');
      }
    } catch (error) {
      console.error('Notification error:', error);
      toast.error('Could not enable notifications');
    }
  };

  const disableNotifications = () => {
    toast.info('To disable notifications: Click browser address bar → Site Settings (🔒) → Notifications → Block');
  };

  if (!supported || !user) {
    return null;
  }

  return (
    <div className="inline-flex">
      {permission === 'granted' ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={disableNotifications}
          className="gap-2 text-green-600 hover:text-green-700"
          title={t('notifications.enabledTitle')}
        >
          <Bell className="h-4 w-4" />
        </Button>
      ) : (
        <Button
          variant="ghost"
          size="sm"
          onClick={requestPermission}
          className="gap-2 text-gray-600 hover:text-teal-600 dark:text-gray-400 dark:hover:text-teal-400"
          title={t('notifications.enableTitle')}
        >
          <BellOff className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
